import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Mountain } from "lucide-react";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { waLink } from "../../lib/site";

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/group-tours", label: "Group Tours" },
  { to: "/family-tours", label: "Family Tours" },
  { to: "/about-us", label: "About Us" },
  { to: "/contact-us", label: "Contact Us" },
];

export const Logo = ({ light }) => (
  <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
    <span className="grid h-9 w-9 place-items-center rounded-xl bg-[#FD691B] text-white"><Mountain className="h-5 w-5" /></span>
    <span className={`font-display text-lg font-extrabold leading-none ${light ? "text-white" : "text-[#171717]"}`}>
      Wandervibe<span className="block text-[10px] font-medium uppercase tracking-[0.3em] text-[#FD691B]">Journeys</span>
    </span>
  </Link>
);

const linkCls = ({ isActive }) =>
  `font-display text-sm font-semibold transition-colors ${isActive ? "text-[#FD691B]" : "text-[#171717] hover:text-[#FD691B]"}`;

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 border-b border-slate-200/80 bg-white/90 backdrop-blur-md" data-testid="site-header">
      <div className="container-x flex h-[72px] items-center justify-between gap-4">
        <Logo />
        <nav className="hidden items-center gap-7 lg:flex" aria-label="Main navigation">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end className={linkCls} data-testid={`nav-link-${n.label.toLowerCase().replace(/\s/g, "-")}`}>{n.label}</NavLink>
          ))}
          <a href={waLink()} target="_blank" rel="noreferrer" aria-label="Chat on WhatsApp" data-testid="nav-whatsapp-btn"
             className="grid h-10 w-10 place-items-center rounded-full bg-[#25D366]/10 text-[#128C7E] transition-colors hover:bg-[#25D366] hover:text-white">
            <WhatsAppIcon />
          </a>
          <Link to="/group-tours" className="btn-brand !py-2.5" data-testid="nav-explore-trips-btn">Explore Trips</Link>
        </nav>
        <div className="flex items-center gap-2 lg:hidden">
          <a href={waLink()} target="_blank" rel="noreferrer" aria-label="Chat on WhatsApp" data-testid="nav-whatsapp-mobile-btn"
             className="grid h-11 w-11 place-items-center rounded-full bg-[#25D366]/10 text-[#128C7E]"><WhatsAppIcon /></a>
          <button onClick={() => setOpen(!open)} aria-label="Toggle menu" data-testid="nav-hamburger-btn"
                  className="grid h-11 w-11 place-items-center rounded-full border border-slate-200">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="border-t border-slate-100 bg-white lg:hidden" data-testid="mobile-menu">
          <div className="container-x flex flex-col gap-1 py-4">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} end onClick={() => setOpen(false)} className={({ isActive }) => `${linkCls({ isActive })} rounded-xl px-3 py-3 text-base`}
                       data-testid={`mobile-nav-link-${n.label.toLowerCase().replace(/\s/g, "-")}`}>{n.label}</NavLink>
            ))}
            <Link to="/group-tours" onClick={() => setOpen(false)} className="btn-brand mt-2" data-testid="mobile-explore-trips-btn">Explore Trips</Link>
          </div>
        </nav>
      )}
    </header>
  );
};
